import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:18
* @route 'https://org.proexpert.app/org/finance'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/finance',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:18
* @route 'https://org.proexpert.app/org/finance'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:18
* @route 'https://org.proexpert.app/org/finance'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:18
* @route 'https://org.proexpert.app/org/finance'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:18
* @route 'https://org.proexpert.app/org/finance'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:18
* @route 'https://org.proexpert.app/org/finance'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:18
* @route 'https://org.proexpert.app/org/finance'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::domains
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:34
* @route 'https://org.proexpert.app/org/finance/domains'
*/
export const domains = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: domains.url(options),
    method: 'get',
})

domains.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/finance/domains',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::domains
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:34
* @route 'https://org.proexpert.app/org/finance/domains'
*/
domains.url = (options?: RouteQueryOptions) => {
    return domains.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::domains
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:34
* @route 'https://org.proexpert.app/org/finance/domains'
*/
domains.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: domains.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::domains
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:34
* @route 'https://org.proexpert.app/org/finance/domains'
*/
domains.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: domains.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::domains
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:34
* @route 'https://org.proexpert.app/org/finance/domains'
*/
const domainsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: domains.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::domains
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:34
* @route 'https://org.proexpert.app/org/finance/domains'
*/
domainsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: domains.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgFinanceController::domains
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgFinanceController.php:34
* @route 'https://org.proexpert.app/org/finance/domains'
*/
domainsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: domains.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

domains.form = domainsForm

const finance = {
    index: Object.assign(index, index),
    domains: Object.assign(domains, domains),
}

export default finance